import Api from "@/api/api";

const ChatService = {
    startChat(startChatInput) {
        return Api().post(`/chatbot/start`, startChatInput);
    },
    postChatMessage(postChatMessageInput) {
        return Api().post(`/chatbot/ask`, postChatMessageInput);
    },
    getChat(getChatInput) {
        return Api().post(`/chatbot/get`, getChatInput);
    },
    endChat(endChatInput) {
        return Api().post(`/chatbot/end`, endChatInput);
    },
    rateBotResponse(rateBotResponseInput) {
        return Api().post(`/chatbot/rateResponse`, rateBotResponseInput);
    },
    escalateChat(escalateChatInput) {
        return Api().post(`/chatbot/escalation/escalate`, escalateChatInput);
    },
    declineEscalation(declineEscalationInput) {
        return Api().post(`/chatbot/escalation/decline`, declineEscalationInput);
    },
};

export default ChatService;